<template>
  <div>
    <slot></slot>
    <ul :style="!hideButtonArea ? '' : 'display: none;'">
      <li v-if="isRecaptcha === 'true'" class="mb-5">
        <v-recaptcha
          @validate="checkRecaptcha"
          :site-key="recaptchaKey"
        ></v-recaptcha>
      </li>
      <li
        class="form__item"
        :class="buttonPadding ? 'mb-5' : ''"
      >
        <div
          :style="showButton ? '' : 'display: none;'"
          @click="showDisabledMessage"
          v-if="disableButton"
        >
          <button
            :id="submitBtnId"
            class="mb-5 theme-btn theme-btn--theme"
            :class="buttonClass"
            type="submit"
            disabled
          >
            {{ buttonName }}
          </button>
        </div>
        <button
          :style="showButton ? '' : 'display: none;'"
          :id="submitBtnId"
          class="mb-5 theme-btn theme-btn--theme"
          :class="buttonClass"
          type="submit"
          @click.prevent="submitForm($event, null, validate, externalAjax)"
          v-else
        >
          {{ buttonName }}
        </button>
        <slot name="extra"></slot>
        <div
          v-if="isSendBtn"
          @click="showInfo"
          :style="showButton ? '' : 'display: none;'"
        >
          <button
            id="sendAgreementBtn"
            class="mb-5 theme-btn theme-btn--theme"
            :class="buttonClass"
            type="button"
            @click.prevent="sendAgreement($event)"
            v-if="!disabled"
          >
            {{ buttonSendName }}
          </button>
          <input
            id="sendAgreementBtnValue"
            type="hidden"
            name="allow_send"
            value="1"
            disabled
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import VTextfieldPublic from "./VTextfieldPublic";
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  inject: ["$validator"],
  components: {
    VTextfieldPublic,
  },
  data() {
    return {
      recaptchaTicked: false,
      disabled: !this.isReadyToSend,
      disableButton: this.disableSubmitButton,
      needReload: this.forceReload,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
  },
  props: {
    buttonName: {
      default: "Submit",
      type: String,
    },
    buttonSendName: {
      default: "Send",
      type: String,
    },
    buttonAlign: {
      default: "left",
      type: String,
    },
    showSuccess: {
      default: 1,
      type: Number,
    },
    successText: {
      default: "",
      type: String,
    },
    successSendText: {
      default: "",
      type: String,
    },
    errorText: {
      default: "",
      type: String,
    },
    isRecaptcha: {
      default: "false",
      type: String,
    },
    recaptchaMessage: {
      default: "Please tick recaptcha",
      type: String,
    },
    recaptchaKey: {
      default: "",
      type: String,
    },
    shouldConfirm: {
      default: false,
      type: Boolean,
    },
    isSendBtn: {
      default: false,
      type: Boolean,
    },
    isReadyToSend: {
      default: false,
      type: Boolean,
    },
    confirmText: {
      default: "",
      type: String,
    },
    infoMessage: {
      default: "",
      type: String,
    },
    disableSubmitButton: {
      default: false,
      type: [Boolean, Number],
    },
    disabledSubmitMessage: {
      default: "",
      type: String,
    },
    submitBtnId: {
      default: "submitBtn",
      type: String,
    },
    confirmDangerMode: {
      default: false,
      type: [Boolean, Number],
    },
    showButton: {
      default: true,
      type: Boolean,
    },
    noRedirect: {
      default: false,
      type: Boolean,
    },
    buttonClass: {
      default: "",
      type: String,
    },
    validate: {
      default: false,
      type: Boolean,
    },
    externalAjax: {
      default: false,
      type: Boolean,
    },
    submitFn: {
      default: () => 1,
      type: Function,
    },
    fnParams: {
      default: () => [],
      type: [Array, Object],
    },
    buttonPadding: {
      default: true,
      type: Boolean,
    },
    forceReload: {
      default: false,
      type: Boolean,
    },
    hideButtonArea: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    checkRecaptcha: function (result) {
      if (result === false) {
        this.recaptchaTicked = false;
      } else {
        this.recaptchaTicked = true;
      }
    },
    sendAjax: function (form, event, button = null) {
      let uploadTarget = $(form).find('input[type="file"]');
      var data = new FormData();
      let postData = form.serializeArray(),
        that = this,
        message = "",
        frameSrc = document.getElementById("showRacPdf")
          ? document.getElementById("showRacPdf").src
          : "",
        $target = $(event.target),
        element = !$target.is("#sendAgreementBtn")
          ? this.submitBtnId
          : "sendAgreementBtn";

      if (button) {
        postData.push({ name: "submit", value: button });
      }
      for (let i = 0; i < postData.length; i++) {
        data.append(postData[i].name, postData[i].value);
      }
      if (uploadTarget.length) {
        for (let i = 0; i < uploadTarget.length; i++) {
          if (uploadTarget[i].files.length) {
            data.append(uploadTarget[i].name, uploadTarget[i].files[0]);
          }
        }
      }
      document.getElementById(element).classList.add("disabled-state");
      // setTimeout(function () {
      //   document.getElementById(element).classList.remove('disabled-state');
      // }, 2000);

      message = !$target.is("#sendAgreementBtn")
        ? this.successText
        : this.successSendText;

      var errorMessage = this.errorText;
      if (this.showSuccess) {
        document.querySelector(".js-loader-item").style.display = "";

        $.ajax({
          url: form.attr("action"),
          method: "post",
          data: data,
          enctype: "multipart/form-data",
          processData: false,
          contentType: false,
          cache: false,
          success: function (result, textStatus, xhr) {
            if (xhr.status == 303) {
              window.location.replace(result.redirect);
            }
            if (
              result &&
              (result.url !== undefined || result.redirect !== undefined)
            ) {
              document.querySelector(".js-loader-item").style.display = "none";
              if (result.error) {
                var err =
                  result.error !== ""
                    ? result.error
                    : window.app.locales.common.error;
                sweetalert(window.app.locales.common.error, err, "error");
              } else if (message !== "") {
                sweetalert(
                  window.app.locales.common.success,
                  message,
                  "success"
                ).then((res) => {
                  if (
                    !that.noRedirect &&
                    (!that.isSendBtn || result.redirect)
                  ) {
                    var redirect = result.url;
                    if (result.redirect) {
                      redirect = result.redirect;
                    }
                    window.location.replace(redirect);
                  } else {
                    if (!$target.is("#sendAgreementBtn")) {
                      window.app.emitEvent("sign-is-saved");

                      if (result.redirect) {
                        redirect = result.redirect;
                        window.location.replace(redirect);
                      }
                      if (result.html) {
                        window.app.documentHtmlPreview = result.html;
                      }
                      if(document.getElementById("showRacPdf")){
                        setTimeout(function () {
                          document.getElementById("showRacPdf").src = result.pdf
                            ? "/viewer/web/index.html?file=" + result.pdf
                            : frameSrc;
                        }, 700);
                      }
                      setTimeout(function () {
                        if (result.disableSubmit && result.disableSubmit == 1) {
                          that.disableButton = true;
                        } else {
                          that.disableButton = false;
                        }
                        if (
                          !document.querySelectorAll(".canvas-holder").length &&
                          !document.querySelectorAll(".no-sign-saved").length &&
                          result.landlordSignatureExists &&
                          result.tenantSignaturesExists
                        ) {
                          that.disabled = false;
                        }
                      }, 900);
                    }
                  }
                });
              } else {
                sweetalert(
                  window.app.locales.common.success,
                  window.app.locales.subscriptions.successfully_added,
                  "success"
                ).then((res) => {
                  if (!that.isSendBtn || result.redirect) {
                    var redirect = result.url;
                    if (result.redirect) {
                      redirect = result.redirect;
                    }
                    window.location.replace(redirect);
                  } else {
                    if (!$target.is("#sendAgreementBtn")) {
                      window.app.emitEvent("sign-is-saved");
                      that.documentHtmlPreview = result.html;
                      if(document.getElementById("showRacPdf")){
                        setTimeout(function () {
                          document.getElementById("showRacPdf").src = frameSrc;
                        }, 700);
                      }
                      setTimeout(function () {
                        if (
                          !document.querySelectorAll(".canvas-holder").length &&
                          !document.querySelectorAll(".no-sign-saved").length &&
                          result.landlordSignatureExists &&
                          result.tenantSignaturesExists
                        ) {
                          that.disabled = false;
                        }
                      }, 900);
                    }
                  }
                });
              }
            } else if(that.forceReload) {
              document.querySelector(".js-loader-item").style.display = "none";

              sweetalert(
                window.app.locales.common.success,
                window.app.locales.subscriptions.successfully_added,
                "success"
              ).then((res) => {
                  window.location.reload();
                });
            } else {
              document.querySelector(".js-loader-item").style.display = "none";
              if (result.error) {
                var err =
                  result.error !== ""
                    ? result.error
                    : window.app.locales.common.error;
                sweetalert(window.app.locales.common.error, err, "error");
              } else {
                if (that.needReload) {
                  sweetalert(
                    window.app.locales.common.success,
                    window.app.locales.subscriptions.successfully_added,
                    "success"
                  ).then((res) => {
                    window.location.reload();
                  });
                } else {
                  sweetalert(
                    window.app.locales.common.success,
                    window.app.locales.subscriptions.successfully_added,
                    "success"
                  );
                }
              }
            }
            document.getElementById(element).classList.remove("disabled-state");
          },
          error: function (result) {
            document.querySelector(".js-loader-item").style.display = "none";
            if (result.status == 303) {
              window.location.replace(result.responseJSON.redirect);
            } else if (
              result &&
              result.responseJSON &&
              result.responseJSON.url !== undefined
            ) {
              if (result.responseJSON.error) {
                sweetalert(
                  window.app.locales.common.error,
                  result.responseJSON.error,
                  "error"
                ).then((res) => {
                  window.location.replace(result.responseJSON.url);
                });
              } else if (errorMessage !== "") {
                sweetalert(
                  window.app.locales.common.error,
                  errorMessage,
                  "error"
                ).then((res) => {
                  window.location.replace(result.responseJSON.url);
                });
              } else {
                sweetalert(
                  window.app.locales.common.error,
                  window.app.locales.common.error,
                  "error"
                ).then((res) => {
                  window.location.replace(result.responseJSON.url);
                });
              }
            } else {
              if (result.responseJSON.error_message !== "") {
                sweetalert(
                  window.app.locales.common.error,
                  result.responseJSON.error_message,
                  "error"
                );
              } else {
                sweetalert(
                  window.app.locales.common.error,
                  window.app.locales.common.error,
                  "error"
                );
              }
            }
            document.getElementById(element).classList.remove("disabled-state");
          },
        });
      } else {
        form.submit();
      }
    },
    submitForm: function (
      e,
      button = null,
      validate = true,
      externalAjax = false
    ) {
      let form = $(e.target).parents("form").first(),
        element = document.getElementById("sendAgreementBtnValue");
      var that = this;
      var scope = null;
      if (form.length) {
        scope = form[0].id;
      }
      if (typeof element != "undefined" && element != null) {
        element.setAttribute("disabled", true);
      }
      if (!externalAjax) {
        if (validate) {
          this.$validator.validateAll(scope).then((res) => {
            if (this.isRecaptcha === "true") {
              if (!this.recaptchaTicked) {
                sweetalert(
                  window.app.locales.common.error,
                  this.recaptchaMessage,
                  "error"
                );
                return;
              }
            }
            if (res) {
              var confirm = this.confirmText;
              if (this.shouldConfirm) {
                sweetalert(confirm, {
                  buttons: [
                    window.app.locales.common &&
                      window.app.locales.common.cancel,
                    "Ok",
                  ],
                  dangerMode: that.confirmDangerMode,
                }).then((value) => {
                  if (value) {
                    this.sendAjax(form, e, button);
                  }
                });
              } else {
                this.sendAjax(form, e, button);
              }
            } else {
              sweetalert(
                window.app.locales.common.error,
                window.app.locales.subscriptions.form_with_errors,
                "error"
              );
            }
          });
        } else {
          this.sendAjax(form, e, button);
        }
      } else {
        that.submitFn(e, ...that.fnParams);
      }
    },
    sendAgreement: function (event) {
      document
        .getElementById("sendAgreementBtnValue")
        .removeAttribute("disabled");

      let form = $(event.target).parents("form").first();
      this.sendAjax(form, event);
    },
    showInfo: function () {
      let that = this;

      if (that.disabled) {
        sweetalert(window.app.locales.common.info, that.infoMessage, "info");
      }
    },
    showDisabledMessage: function () {
      let that = this;
      sweetalert(
        window.app.locales.common.info,
        that.disabledSubmitMessage,
        "info"
      );
    },
  },
};
</script>